module.exports = __webpack_public_path__ + "img/huilan.828246b0.png";